import { useEffect, useState } from "react";
import { Alert, Card, CardBody, CardHeader, Col, Form, FormGroup, Row } from "react-bootstrap";
import { TrashBinOutline } from 'react-ionicons';
import { useNavigate } from "react-router-dom";
import Api from "../../utils/api";
import ButtonSave from "../components/ButtonSave";



const SourceAdd = () => {

    //const { id } = useParams();

    const navigate = useNavigate()

    const [source, setSource] = useState({
        name: '',
        url: '',
        urlBackup: '',
        status: true,
        server: 1,
        type: 'repeater'
    });

    const save = async () => {
        const result = await Api.post('/streams', source)
        if (result.success) {
            const id = parseInt(result.data);
            if (id > -1) {
                navigate('/sources/' + id)
            }
        }
    };

    const updateSource = (event) => {
        let { name, value } = event.target;

        if (name === 'isBackup' || name === 'status') {
            value = value === '1' ? true : false
        } else if (name === 'server') {
            value = parseInt(value);
        }

        setSource((state) => ({
            ...state,
            [name]: value,
        }));
    };

    useEffect(() => {
        console.log(source)
    }, [source]);

    if (source === null) {
        return (
            <>Cargando...</>
        )
    }

    return (
        <>

            <Form className="mt-5">
                <Card>
                    <CardHeader>
                        <Row className="justify-content-between">

                            <Col>
                                Nueva fuente
                            </Col>


                            <Col className="text-end" title="Eliminar">
                                <TrashBinOutline color={'#fff'} style={{ cursor: 'pointer' }} />
                            </Col>
                        </Row>
                    </CardHeader>

                    <CardBody>

                        <Row className="row mb-3">
                            <Col md={8}>
                                <FormGroup>
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control name="name" defaultValue={source.name} onChange={updateSource} />
                                </FormGroup>

                                <FormGroup className="mt-3">
                                    <Form.Label>URL</Form.Label>
                                    <Form.Control name="url" defaultValue={source.url} onChange={updateSource} />
                                </FormGroup>

                                <FormGroup className="mt-3">
                                    <Form.Label>URL Backup</Form.Label>
                                    <Form.Control name="urlBackup" defaultValue={source.urlBackup} onChange={updateSource} />
                                </FormGroup>
                            </Col>
                            <Col md={3} offset={1}>
                                <FormGroup>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select name="status" defaultValue={source.status ? '1' : '0'} onChange={updateSource}>
                                        <option value="1">Activado</option>
                                        <option value="0">Desactivado</option>
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup className="mt-3">
                                    <Form.Label>Servidor</Form.Label>
                                    <Form.Select name="server" defaultValue={source.server} onChange={updateSource}>
                                        {Api.servers.map((server) =>
                                            <option key={server.id} value={server.id}>{server.name}</option>
                                        )}
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup className="mt-3">
                                    <Form.Label>Tipo</Form.Label>
                                    <Form.Select name="type" defaultValue={source.type} onChange={updateSource}>
                                        <option value="repeater">Normal</option>
                                        <option value="generator">Generador</option>
                                    </Form.Select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-end mt-3">

                            <ButtonSave onClick={save} />
                        </div>
                    </CardBody>
                </Card>

                <Alert variant="warning" className="mt-4">
                    Guarde los cambios para poder agregar salidas
                </Alert>




            </Form>
        </>
    );
}

export default SourceAdd;